interface Props {
  value: number;
  goal: number;
  label: string;
  size?: number;
  stroke?: number;
  /** Единица под числом в центре - «г» для макронутриентов. */
  unit?: string;
  /** CSS-переменная цвета дуги: кольцо должно совпадать с буквой в плашке. */
  color?: string;
}

/**
 * Кольцо прогресса к цели.
 *
 * Внутри нормы дуга своего цвета - того же, которым помечена буква в плашке
 * итога. За нормой становится красной и замкнутой: перебор должен читаться
 * сразу, без сверки чисел.
 */
export function ProgressRing({
  value,
  goal,
  label,
  size = 74,
  stroke = 7,
  unit,
  color,
}: Props) {
  const r = (size - stroke) / 2;
  const circumference = 2 * Math.PI * r;
  const ratio = goal > 0 ? value / goal : 0;
  const over = ratio > 1;

  return (
    <div className="pring" style={color ? { ['--ring-color' as string]: color } : undefined}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        role="img"
        aria-label={`${label}: ${Math.round(value)} из ${Math.round(goal)}${unit ? ' ' + unit : ''}`}
      >
        <circle
          className="pring-track"
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={stroke}
        />
        <circle
          className={`pring-value${over ? ' over' : ''}`}
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - Math.min(ratio, 1))}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
        <text className="pring-center" x="50%" y="50%" textAnchor="middle" dy="0.36em">
          {Math.round(value)}
        </text>
      </svg>
      <span className="pring-label">{label}</span>
    </div>
  );
}
